import { Component, Input } from '@angular/core';

import { PointHistoryType } from 'libs/domain';
import { points_pb } from 'libs/generated-grpc-web';

import { dateMessageObjectToDateObject } from '@app/src/app/util/date';

@Component({
  selector: 'mg-points-history-item',
  templateUrl: './PointsHistoryItem.component.html',
  styleUrls: ['./PointsHistoryItem.component.scss'],
})
export class PointsHistoryItemComponent {
  private _item?: points_pb.PointsHistoryItem.AsObject;

  typeClass = 'custom';
  itemDate?: Date;

  @Input()
  set item(newItem: points_pb.PointsHistoryItem.AsObject | undefined) {
    this._item = newItem;

    if (newItem?.date) {
      this.itemDate = dateMessageObjectToDateObject(newItem.date);
    }

    this.typeClass = this.getTypeClass();
  }
  get item(): points_pb.PointsHistoryItem.AsObject | undefined {
    return this._item;
  }

  constructor() {}

  getTypeClass(): string {
    if (!this.item || !this.item.type) return 'custom';

    switch (this.item.type) {
      case PointHistoryType.EVENT_CHECKIN:
        return 'event';
      case PointHistoryType.TEXT_CHALLENGE_RESPONSE:
        return 'text-challenge';
      case PointHistoryType.POLL_RESPONSE:
        return 'poll';
      case PointHistoryType.IMAGE_CHALLENGE_RESPONSE:
        return 'image-challenge';
      case PointHistoryType.CUSTOM:
      default:
        return 'custom';
    }
  }
}
